import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'InfantClubIcon',
  props: {
    width: null,
    height: null
  },
  setup(__props: any) {

const props = __props as {
	width?: number;
	height?: number;
}

// Props


return { __sfc: true,props }
}

})